export default function() {
    const self = this,
        postId = self.$route.params.id

    self.post = {
        roles: [null]
    }
    self.resetFormResult()

    if (postId) {
        self.loadPost(postId)
    }
}
